import { createEntityAdapter } from "@reduxjs/toolkit";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import { createAppSlice } from "../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import { name } from "../config/name.js";
const adapter = createEntityAdapter({
  selectId: (item) => item.vehicleId
});
const initialState = adapter.getInitialState();
const slice = createAppSlice({
  name,
  initialState,
  reducers: {
    reset: () => initialState,
    setOne: adapter.setOne,
    removeOne: adapter.removeOne
  }
});
const { reducer, actions, reducerPath } = slice;
const selectors = adapter.getSelectors();
export {
  actions,
  adapter,
  reducer,
  reducerPath,
  selectors,
  slice
};
